import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  inputWithAddBtn: {
    alignItems: "flex-end",
    display: "flex",
    flex: 1,
    gap: theme.spacing(1),
    justifyContent: "flex-start",
  },
  errorContainer: {
    color: theme.color.red,
    marginBottom: 20,
  },
  formRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: theme.spacing(3),
    marginBottom: 20,
    marginTop: 20,
  },
  formCol: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
}));
